import state from './flows.store'
import getters from './flows.getters'
import mutations from './flows.mutations'
import actions from './flows.actions'

export default {
  namespaced: true,
  getters,
  mutations,
  state,
  actions
}
